const SvgWarningIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 22 20" {...props}>
    <g fill="#A88100">
      <path d="m11 4.49 7.53 13.01H3.47zM11 .5l-11 19h22z" />
      <path d="M12 14.5h-2v2h2zM12 8.5h-2v5h2z" />
    </g>
  </svg>
);

export default SvgWarningIcon;
